// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-container-new {
  position: relative;
  width: 600px;
  height: 600px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.central-wrapper-new {
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 3px dotted #ddd;
  display: flex;
  justify-content: center;
  align-items: center;
}

.central-image-new {
  position: absolute;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.central-image-new img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.circular-item-new {
  position: absolute;
  display: flex;
  align-items: center;
  transform-origin: center;
}

.line-new {
  position: absolute;
  width: 120px !important;
  height: 0.15px !important;
  background: transparent;
  border-top: 2px dashed #000 !important;
  transform-origin: left;
}

.line-1-new {
  width: 52.5% !important;
  transform: rotate(-50deg);
  top: 300% !important;
  right: 56% !important;
}
.line-2-new {
  top: 50%;
  left: -73% !important;
  width: 73% !important;
  transform: rotate(0deg);
}
.line-3-new {
  top: -5%;
  left: 25%;
  width: 43% !important;
  transform: rotate(230deg);
}
.line-4-new {
  top: 50%;
  left: 173%;
  width: 71% !important;
  transform: rotate(180deg);
}
.line-5-new {
  top: 314%;
  left: 130%;
  width: 76% !important;
  transform: rotate(225deg);
}
.line-6-new {
  top: -10%;
  left: 74%;
  width: 73% !important;
  transform: rotate(321deg);
}
.circular-button-new {
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid black;
  border-radius: 50px;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.1s ease;
  gap: 10px;
}

.circular-button-new.reverse {
  flex-direction: row;
}

.circular-button-new.reverse img {
  margin-right: 0 !important;
  margin-left: 5px !important;
}

.circular-item-new .circular-button-new:hover {
  background-color: #abe46c;
}

.circular-button-new.active-button-new {
  background-color: #abe46c;
  color: black;
  cursor: default;
}

.circular-button-new:hover {
  transform: scale(1.2);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.circular-button-new:hover img {
  transform: scale(1.1);
}

.circular-button-new.reverse:hover {
  transform: scale(1.1);
}

.circular-item-new img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.circular-item-new p {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
}

.page-section-new {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  margin-bottom: -50px;
  margin-top: -80px;
}

.page-section-new h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
}

.page-section-new p {
  font-size: 1.2em;
  color: #555;
}

@media screen and (max-width: 768px) {
  .circular-container-new {
    width: 400px;
    height: 400px;
    padding-bottom: 30px;
  }
  .central-image-new img {
    width: 60%;
    height: 60%;
    border-radius: 50%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }

  .central-wrapper-new {
    position: absolute;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 3px dotted #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 30px;
  }
  .central-image-new {
    position: absolute;
    width: 1%;
    height: 1%;
    border-radius: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .central-image-new {
    width: 120px;
    height: 120px;
    margin-right: 0px;
  }

  .circular-item-new {
    transform-origin: center;
  }

  .circular-button-new {
    padding: 4px 2px;
    gap: 0px;
  }

  .circular-item-new p {
    font-size: 10px;
  }

  .line-new {
    width: 60px !important;
    height: 0.1px !important;
    border-top: 1px dashed #000 !important;
  }

  .line-1-new {
    width: 35% !important;
    transform: rotate(-50deg);
    top: 190% !important;
    left: 20% !important;
  }
  .line-2-new {
    top: 40%;
    left: -10% !important;
    width: 10% !important;
    transform: rotate(0deg);
  }
  .line-3-new {
    top: -5%;
    left: 30%;
    width: 35% !important;
    transform: rotate(240deg);
  }
  .line-4-new {
    top: 43%;
    left: 122%;
    width: 23% !important;
    transform: rotate(180deg);
  }
  .line-5-new {
    top: 188%;
    left: 96%;
    width: 42% !important;
    transform: rotate(230deg);
  }
  .line-6-new {
    top: -5%;
    left: 65%;
    width: 51% !important;
    transform: rotate(308deg);
  }
  .circular-button-new {
    gap: 1%;
  }
  .circular-button-new:hover img {
    transform: scale(0.9);
  }

  .circular-button-new.reverse:hover {
    transform: scale(1.1);
  }
  .circular-button-new:hover {
    transform: scale(1.1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CircularDesignNew/CircularDesignNew.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,QAAQ;EACR,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,oBAAoB;EACtB;EACA;IACE,QAAQ;IACR,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".circular-container-new {\n  position: relative;\n  width: 600px;\n  height: 600px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.central-wrapper-new {\n  position: absolute;\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  border: 3px dotted #ddd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.central-image-new {\n  position: absolute;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.central-image-new img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n}\n\n.circular-item-new {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  transform-origin: center;\n}\n\n.line-new {\n  position: absolute;\n  width: 120px !important;\n  height: 0.15px !important;\n  background: transparent;\n  border-top: 2px dashed #000 !important;\n  transform-origin: left;\n}\n\n.line-1-new {\n  width: 52.5% !important;\n  transform: rotate(-50deg);\n  top: 300% !important;\n  right: 56% !important;\n}\n.line-2-new {\n  top: 50%;\n  left: -73% !important;\n  width: 73% !important;\n  transform: rotate(0deg);\n}\n.line-3-new {\n  top: -5%;\n  left: 25%;\n  width: 43% !important;\n  transform: rotate(230deg);\n}\n.line-4-new {\n  top: 50%;\n  left: 173%;\n  width: 71% !important;\n  transform: rotate(180deg);\n}\n.line-5-new {\n  top: 314%;\n  left: 130%;\n  width: 76% !important;\n  transform: rotate(225deg);\n}\n.line-6-new {\n  top: -10%;\n  left: 74%;\n  width: 73% !important;\n  transform: rotate(321deg);\n}\n.circular-button-new {\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 2px solid black;\n  border-radius: 50px;\n  padding: 5px 10px;\n  cursor: pointer;\n  transition: background-color 0.1s ease;\n  gap: 10px;\n}\n\n.circular-button-new.reverse {\n  flex-direction: row;\n}\n\n.circular-button-new.reverse img {\n  margin-right: 0 !important;\n  margin-left: 5px !important;\n}\n\n.circular-item-new .circular-button-new:hover {\n  background-color: #abe46c;\n}\n\n.circular-button-new.active-button-new {\n  background-color: #abe46c;\n  color: black;\n  cursor: default;\n}\n\n.circular-button-new:hover {\n  transform: scale(1.2);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.circular-button-new:hover img {\n  transform: scale(1.1);\n}\n\n.circular-button-new.reverse:hover {\n  transform: scale(1.1);\n}\n\n.circular-item-new img {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.circular-item-new p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.page-section-new {\n  margin-top: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  margin-bottom: -50px;\n  margin-top: -80px;\n}\n\n.page-section-new h2 {\n  font-size: 1.8em;\n  margin-bottom: 20px;\n}\n\n.page-section-new p {\n  font-size: 1.2em;\n  color: #555;\n}\n\n@media screen and (max-width: 768px) {\n  .circular-container-new {\n    width: 400px;\n    height: 400px;\n    padding-bottom: 30px;\n  }\n  .central-image-new img {\n    width: 60%;\n    height: 60%;\n    border-radius: 50%;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);\n  }\n\n  .central-wrapper-new {\n    position: absolute;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    border: 3px dotted #ddd;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 30px;\n  }\n  .central-image-new {\n    position: absolute;\n    width: 1%;\n    height: 1%;\n    border-radius: 30%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .central-image-new {\n    width: 120px;\n    height: 120px;\n    margin-right: 0px;\n  }\n\n  .circular-item-new {\n    transform-origin: center;\n  }\n\n  .circular-button-new {\n    padding: 4px 2px;\n    gap: 0px;\n  }\n\n  .circular-item-new p {\n    font-size: 10px;\n  }\n\n  .line-new {\n    width: 60px !important;\n    height: 0.1px !important;\n    border-top: 1px dashed #000 !important;\n  }\n\n  .line-1-new {\n    width: 35% !important;\n    transform: rotate(-50deg);\n    top: 190% !important;\n    left: 20% !important;\n  }\n  .line-2-new {\n    top: 40%;\n    left: -10% !important;\n    width: 10% !important;\n    transform: rotate(0deg);\n  }\n  .line-3-new {\n    top: -5%;\n    left: 30%;\n    width: 35% !important;\n    transform: rotate(240deg);\n  }\n  .line-4-new {\n    top: 43%;\n    left: 122%;\n    width: 23% !important;\n    transform: rotate(180deg);\n  }\n  .line-5-new {\n    top: 188%;\n    left: 96%;\n    width: 42% !important;\n    transform: rotate(230deg);\n  }\n  .line-6-new {\n    top: -5%;\n    left: 65%;\n    width: 51% !important;\n    transform: rotate(308deg);\n  }\n  .circular-button-new {\n    gap: 1%;\n  }\n  .circular-button-new:hover img {\n    transform: scale(0.9);\n  }\n\n  .circular-button-new.reverse:hover {\n    transform: scale(1.1);\n  }\n  .circular-button-new:hover {\n    transform: scale(1.1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
